import React from 'react';

import { formatAmount } from 'helpers/helpers';
import Grid from '@material-ui/core/Grid';
import H2 from 'apps/Pdf/components/common/H2';
import Spacer from 'apps/Pdf/components/common/Spacer';

import useGeneralStyles from 'apps/Pdf/styles/general';
import { FinancesOverviewData } from '../StatementInterface';
import { Currency } from 'enums';

interface Props {
  title: string;
  data: FinancesOverviewData;
  currency: Currency;
}

const FinancesOverview = (props: Props) => {
  const styles = useGeneralStyles();
  const { data, currency } = props;

  return (
    <Grid container className={styles.lines}>
      <H2>{props.title}</H2>
      <Grid item xs={6}>
        Počáteční zůstatek:
      </Grid>
      <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
        {formatAmount(data.openingBalance, currency)}
      </Grid>
      <Spacer variant="quarter" />
      <Grid item xs={6}>
        Vklady:
      </Grid>
      <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
        {formatAmount(data.deposits, currency)}
      </Grid>
      {data.employer && (
        <>
          <Grid item xs={6}>
            Vklady zaměstnavatele:
          </Grid>
          <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
            {formatAmount(data.employer, currency)}
          </Grid>
        </>
      )}
      <Grid item xs={6}>
        Výběry:
      </Grid>
      <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
        {formatAmount(data.withdrawals, currency)}
      </Grid>
      {data.transfers !== undefined && data.transfers !== null && (
        <>
          <Grid item xs={6}>
            Převod cenných papírů:
          </Grid>
          <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
            {formatAmount(data.transfers, currency)}
          </Grid>
        </>
      )}
      <Grid item xs={6}>
        Výnosy portfolií:
      </Grid>
      <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
        {formatAmount(data.profits, currency)}
      </Grid>
      <Grid item xs={6}>
        Náklady (poplatky):
      </Grid>
      <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
        {formatAmount(data.fees, currency)}
      </Grid>
      <Spacer variant="quarter" />
      <Grid item xs={6}>
        Konečný zůstatek
      </Grid>
      <Grid item xs={6} className={`${styles.value} ${styles.right}`}>
        {formatAmount(data.closingBalance, currency)}
      </Grid>
    </Grid>
  );
};

export default FinancesOverview;
